import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { getLeadById, ILead } from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import { isBlank } from '../../../utils/StringUtils';

import LeadDetailsForm from './LeadDetailsForm';

interface CreateLeadDrawerProps {
  open: boolean;
  onClose: () => void;
  leadId: string | null;
  postSubmit?: (lead: ILead) => void;
}

const CreateLeadDrawer = ({ open, onClose, leadId, postSubmit }: CreateLeadDrawerProps) => {
  const [leadData, setLeadData] = useState<ILead>();

  useEffect(() => {
    const fetchData = async () => {
      if (leadId) {
        const response = await getLeadById(leadId);
        if (response.status === 200) {
          setLeadData(response.data);
        }
      }
    };
    fetchData();
  }, [leadId]);

  if (!isBlank(leadId) && !leadData) return null;

  return (
    <WsDrawer
      open={open}
      onClose={onClose}
      size="small"
      title={leadId ? 'Edit Lead' : 'Create Lead'}
      headerSize="medium"
    >
      <Box display="flex" p={2}>
        <LeadDetailsForm defaultLeadData={leadData} postSubmit={postSubmit} />
      </Box>
    </WsDrawer>
  );
};

export default CreateLeadDrawer;
